/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefetchContainer_shippingFilters$ref = any;
export type SbSharedRefetchContainer_shippingFilters = ReadonlyArray<{
    readonly totalCount: number | null;
    readonly " $refType": SbSharedRefetchContainer_shippingFilters$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefetchContainer_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'd5ad44746e573a35fa3db0693e7d384d';
export default node;
